export default "/_next/static/images/7e951cbfaf95ecfdd7d7feeca9a72a1c.jpg";